import { render, staticRenderFns } from "./goodsManage.vue?vue&type=template&id=ff12d130&scoped=true&"
import script from "./goodsManage.vue?vue&type=script&lang=js&"
export * from "./goodsManage.vue?vue&type=script&lang=js&"
import style0 from "./goodsManage.vue?vue&type=style&index=0&lang=less&"
import style1 from "./goodsManage.vue?vue&type=style&index=1&id=ff12d130&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff12d130",
  null
  
)

export default component.exports